/**
 * Shared JSX components for the Markets section (MarketsPage,
 * StockQuotePage, MoversPage) — the section-level error banner and the
 * "stale/cached data" chip that every markets endpoint can surface via its
 * `stale` flag.
 *
 * Non-component constants/helpers (chart theme tokens, SectionError type,
 * toSectionError) live in marketsTheme.ts instead, so this file only
 * exports components (required for React Fast Refresh). Pure formatting
 * helpers (currency, percent, dates) live in marketsFormat.ts.
 */
import type { SectionError } from './marketsTheme'

export function SectionErrorBanner({ error }: { error: SectionError | null }): React.JSX.Element | null {
  if (!error) return null
  return (
    <div className={`gd-banner gd-banner--${error.kind}`} role={error.kind === 'error' ? 'alert' : 'status'}>
      <span className="material-icons" aria-hidden="true">
        {error.kind === 'error' ? 'warning' : 'info'}
      </span>
      <p>{error.message}</p>
    </div>
  )
}

export function StaleChip(): React.JSX.Element {
  return (
    <span
      className="gd-stale-chip"
      title="The backend served a cached copy because the market data provider was unreachable"
    >
      <span className="material-icons" aria-hidden="true">cloud_off</span>
      cached data — provider unreachable
    </span>
  )
}
